import {
  ADD_SUBSCRIPTION_PURCHASE,
  ADD_SUBSCRIPTION_PURCHASE_SUCCESS,
  ADD_SUBSCRIPTION_PURCHASE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const addSubscriptionPurchaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SUBSCRIPTION_PURCHASE:
      return { ...state, loading: true };
    case ADD_SUBSCRIPTION_PURCHASE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case ADD_SUBSCRIPTION_PURCHASE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default addSubscriptionPurchaseReducer;
